import { render, staticRenderFns } from "./TwAddGoodsSubFlow.vue?vue&type=template&id=507f8109&"
import script from "./TwAddGoodsSubFlow.vue?vue&type=script&lang=js&"
export * from "./TwAddGoodsSubFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports